module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CatalogSubCategoryBox":{"button":{"continue":"Pokračovat"}}}}')
  delete Component.options._Ctor
}
